import type { FormProps } from "antd"
import { Form, message } from "antd"
import Title from "antd/es/typography/Title"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { Paths } from "~/constants"
import { t } from "~/languages/i18n"
import { RootState } from "../../auth/services/redux/store"
import { AttributesRecruitment } from "../../ui-builder"
import { createRecruitment } from "../services/recruitment"
import Department from "./Departments"
import Publish from "./Publish"
import RecruitmentForm from "./RecruitmentForm"

const AddRecruitment = () => {
  const [status, setStatus] = useState("Draft")
  const [language, setLanguages] = useState("vi")
  const [publishDate, setPublishDate] = useState<string | null>(null)
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(null) // Changed to a single string
  const account = useSelector((state: RootState) => state.account)
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const onFinish: FormProps<AttributesRecruitment>["onFinish"] = async values => {
    const dataPayload = {
      Title: values.Title,
      Content: values.Content,
      Department: selectedDepartment || "",
      Rank: values.Rank,
      Quantity: values.Quantity,
      Form: values.Form,
    }

    try {
      await createRecruitment(dataPayload)
      message.success("Recruitment added successfully!")
      form.resetFields()
      navigate(Paths.RECRUITMENT.LIST.PATH)
    } catch (error) {
      message.error("Failed to add recruitment. Please try again.")
    }
  }

  const onFinishFailed: FormProps<AttributesRecruitment>["onFinishFailed"] = () => {
    message.error("Please check the form and fix any errors.")
  }

  const onChangeDepartment = (checkedValue: string) => {
    setSelectedDepartment(checkedValue)
  }

  return (
    <div className="p-4">
      <Title level={2} className="m-0">
        {t("Add New Recruitment")}
      </Title>
      <div className="flex justify-between">
        <RecruitmentForm form={form} onFinish={onFinish} onFinishFailed={onFinishFailed} quillValue="" />
        <div className="w-[22%] pt-2">
          <Publish
            onSubmit={form.submit}
            isCreateEdit={true}
            setStatus={setStatus}
            language={language}
            setLanguages={setLanguages}
            status={status}
            setPublishDate={setPublishDate}
          />
          <Department selectedDepartment={selectedDepartment || ""} onChangeDepartment={onChangeDepartment} />
        </div>
      </div>
    </div>
  )
}

export default AddRecruitment
